/**
 * @author hingjip
 * @fileoverview 字符串工具函数
 */

/**
 * 隐藏姓名，电话或者身份证中间几位
 * @params str 字符串
 * @params frontLen 前面保留位数
 * @params endLen 后面保留位数，默认0
 */
export function hiddenString(str, frontLen, endLen = 0) {
  let len = str.length - frontLen - endLen
  let xing = ''
  for (let i = 0; i < len; i++) {
    xing += '*'
  }
  return str.substring(0, frontLen) + xing + str.substring(str.length - endLen)
}

/**
 * 获取随机字符串
 */
export function getRandomString(e) {
  e = e || 8
  let t = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678',
    a = t.length,
    n = ''
  for (let i = 0; i < e; i++) n += t.charAt(Math.floor(Math.random() * a))
  return n
}
